<div class="callout {{ type }}">
  <ly-icon class="icon" [icon]="icon"></ly-icon>
  <div class="callout-content">
    <ng-content></ng-content>
    <button *ngIf="buttonText" class="button" (click)="onButtonClick()">
      {{ buttonText }}
    </button>
  </div>
</div>
